import React, { useEffect, useState } from "react";
import { Card, Row, Col } from "react-bootstrap";

import { Doughnut } from "react-chartjs-2";
import { getAllStories } from "../../../../api/summaryReport";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";


ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
);
const StorySummary = () => {
  const [unallocatedPercent, setUnallocatedPercent] = useState(0);
  // const [assignedPercent, setAssignedPercent] = useState(0);
  // const [completedPercent, setCompletedPercent] = useState(0);
  // const [inProgressPercent, setInProgressPercent] = useState(0);
  const [allocatedPercent, setAllocatedPercent] = useState(0);

  useEffect(() => {
    fetchStories();
  }, []);

  const fetchStories = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await getAllStories(token);
      const stories = res.data;

      const today = new Date();

      // Active sprint stories
      const activeSprintStories = stories.filter((story) => {
        if (!story.sprint) return false;

        const start = new Date(story.sprint.startDate);
        const end = new Date(story.sprint.endDate);
        end.setHours(23, 59, 59, 999);

        return today >= start && today <= end;
      });


      let unallocated = 0;
      
      activeSprintStories.forEach((story) => {
        if (!story.storyUsers || story.storyUsers.length === 0) {
          unallocated++;
        } 
      });

      const total = activeSprintStories.length;
      
      const unallocatedPercent =
        total > 0 ? Math.round((unallocated / total) * 100) : 0;

      const allocatedPercent = total > 0 ? 100 - unallocatedPercent : 0;

      setAllocatedPercent(allocatedPercent);
      setUnallocatedPercent(unallocatedPercent);
      
    } catch (error) {
      console.error("Error fetching stories", error);
    }

  };

  const data = {
    datasets: [
      {
        data: [unallocatedPercent, allocatedPercent],
        backgroundColor: [
          "#6f2b1c",  // Unallocated
          "#d07a5f",  // Allocated
        ],
        cutout: "55%",
        borderWidth: 0,
      },
    ],
  };


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };

  return (
    <Card className="shadow-sm h-100">
      <style>
        {`
         
            .story-container {
                height: 180px;
              }

.story-donut {
  width: 180px;
  height: 150px;
  margin:auto;
}

.legend-container {
  font-size: 14px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.dot-unallocated {
  background: #6f2b1c;
}


.dot-allocated { background: #d07a5f; }
        `}
      </style>

      <Card.Header className="text-center fw-semibold bg-light">
        Week Story Summary
      </Card.Header>

      <Card.Body className="story-container">

        <Row className="align-items-center">

          {/* Donut Chart */}
          <Col md={6} className="d-flex justify-content-center">
            <div className="story-donut">
              <Doughnut data={data} options={options} />
            </div>
          </Col>

          {/* Labels */}
          <Col md={6}>

            <Row className="mb-2">
              <Col className="d-flex align-items-center">
                <span className="dot dot-unallocated"></span>
                Unallocated Tasks ({unallocatedPercent}%)
              </Col>
            </Row>


            <Row>
              <Col className="d-flex align-items-center">
                <span className="dot dot-allocated"></span>
                Allocated Tasks ({allocatedPercent}%)
              </Col>
            </Row>
          </Col>
        </Row>

      </Card.Body>

    </Card>
  );
};

export default StorySummary;